import { Card, Empty, Skeleton, Table, Typography } from "@douyinfe/semi-ui";
import { DashboardFilters, HomeDashboardApi, LeaderboardItem } from "../api/homeDashboard";
import { useDashboardModule } from "../hooks/useDashboardModule";
import { chartBoxStyle, chartTitleStyle } from "../styles";
import { DrawerMode } from "./DetailDrawer";

interface Props {
  filters: DashboardFilters;
  isAdmin: boolean;
  currentTeamId?: number;
  openDrawer: (title: string, params: Record<string, any>, mode?: DrawerMode) => void;
}

const COLUMNS = [
  { title: "排名", dataIndex: "rank", width: 60 },
  { title: "销售", dataIndex: "saleName" },
  { title: "团队", dataIndex: "teamName" },
  { title: "数量", dataIndex: "count" },
];

export default function LeaderboardCard({ filters, openDrawer }: Props) {
  const newer = useDashboardModule(
    () => HomeDashboardApi.getLeaderboardNew(filters, 10),
    [filters.startDate, filters.endDate, filters.teamId, JSON.stringify(filters.saleIds)],
    !!filters.startDate
  );
  const visit = useDashboardModule(
    () => HomeDashboardApi.getLeaderboardVisit(filters, 10),
    [filters.startDate, filters.endDate, filters.teamId, JSON.stringify(filters.saleIds)],
    !!filters.startDate
  );

  return (
    <Card>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <div style={chartBoxStyle}>
          <Typography.Text style={chartTitleStyle}>销售新客 Top 10</Typography.Text>
          {newer.loading && <Skeleton.Title />}
          {newer.data && newer.data.length > 0 ? (
            <Table<LeaderboardItem> dataSource={newer.data} rowKey="saleId" pagination={false}
              onRow={(r: LeaderboardItem) => ({
                onClick: () => openDrawer(`新客排行 - ${r.saleName}`, { ...filters, saleIds: [r.saleId] }, "assign"),
              })}
              columns={COLUMNS} />
          ) : !newer.loading ? <Empty title="暂无排行数据" /> : null}
        </div>
        <div style={chartBoxStyle}>
          <Typography.Text style={chartTitleStyle}>销售上门 Top 10</Typography.Text>
          {visit.loading && <Skeleton.Title />}
          {visit.data && visit.data.length > 0 ? (
            <Table<LeaderboardItem> dataSource={visit.data} rowKey="saleId" pagination={false}
              onRow={(r: LeaderboardItem) => ({
                onClick: () => openDrawer(`上门排行 - ${r.saleName}`, { ...filters, saleIds: [r.saleId] }, "visit"),
              })}
              columns={COLUMNS} />
          ) : !visit.loading ? <Empty title="暂无排行数据" /> : null}
        </div>
      </div>
    </Card>
  );
}
